import axios from 'axios';
import Chart from 'chart.js/auto';
import { api } from './utils';

export function orgSearch(data: any, callback: any) {
  const url = `${getIBLSEARCHURL()}/api/search/search/${data}`;
  axios
    .get(url)
    .then((response) => {
      // Handle successful response
      callback(response.data);
    })
    .catch((error) => {
      // Handle error
      console.error(error);
    });
}

export function getSkillDescription(skillLevel: number) {
  switch (skillLevel) {
    case 1:
      return 'Can complete narrow and limited tasks requiring basic skills with direct supervision or guidance.';
    case 2:
      return 'Handles routine assignments with some confidence; occasional assistance may be needed.';
    case 3:
      return 'Capable of managing varied tasks; understands nuances but may seek guidance for complexities.';
    case 4:
      return 'Skilled at handling complex scenarios; regularly assists and mentors others in the domain.';
    case 5:
      return 'Demonstrates mastery in tasks, often pioneering solutions; consistently leads by example.';
    default:
      return ''; // Handle invalid skill levels
  }
}

export function getUserId() {
  const userData = JSON.parse((localStorage as any).getItem('userData'));
  return userData.user_id;
}

export function getUserName() {
  const userData = JSON.parse((localStorage as any).getItem('userData'));
  return userData.user_nicename;
}

export function getTenant() {
  // return "main"
  return localStorage.getItem('tenant');
}

export function getParameterByName(name: string, url?: string) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  let parameterValue = decodeURIComponent(results[2].replace(/\+/g, ' '));
  parameterValue = parameterValue.replace(/ /g, '+'); // Replace spaces with "+"
  return parameterValue;
}

export function credentialImageURL(credential: any) {
  return credential.credentialDetails.iconImage || '/images/default_badge.png';
}

export function getRandomImage() {
  const img_url = '/images/courses/';
  const images_array = [
    'c1s.jpeg',
    'c2s.jpeg',
    'c3s.jpeg',
    'c4s.jpeg',
    'c5s.jpeg',
    'c6s.jpeg',
    'c7s.jpeg',
    'c8s.jpeg',
  ];
  const random = Math.floor(Math.random() * images_array.length);
  return img_url + images_array[random];
}

export function secondsToHoursAndMinutes(_seconds: number) {
  const hours = Math.floor(_seconds / 3600);
  const minutes = Math.floor((_seconds % 3600) / 60);
  const seconds = _seconds % 60;

  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes}`;
}

export function formatReadableDate(inputDate: string) {
  // Parse the input date string
  const dateObj = new Date(inputDate);

  // Check if the date is valid
  if (isNaN(dateObj.getTime())) {
    return NaN;
  }

  // Define options for formatting
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  // Format the date
  return dateObj.toLocaleDateString('en-US', options);
}

// TODO : add process.env
export function getIBLSEARCHURL() {
  return process.env.REACT_APP_IBL_SEARCH_URL;
}

export function getYearDateRange() {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  const startMonth = (currentMonth + 12) % 12;
  const endMonth = currentMonth;
  const yearOffset = Math.floor((currentMonth - 12) / 12);
  const startYear = currentYear + yearOffset;

  const startDate = new Date(startYear, startMonth, 1);
  const endDate = new Date(currentYear, endMonth + 1, 0);

  return {
    start: startDate.toISOString().split('T')[0],
    end: endDate.toISOString().split('T')[0],
  };
}

export function formatEarnedOnDate(stringDate: string) {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    year: 'numeric',
    month: 'short',
  };
  const date = new Date(stringDate);
  return date.toLocaleDateString('en-US', options);
}

export function getImageUrl(url: string) {
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

  if (urlRegex.test(url)) {
    return url;
  }

  return '/images/default_avatar.png';
}

export function parseLocalStorageData(key: string) {
  const jsonString = localStorage.getItem(key);

  if (!jsonString) {
    console.error(`No data found in localStorage for key: ${key}`);
    return null;
  }

  try {
    const parsedData = JSON.parse(jsonString);
    return parsedData;
  } catch (error) {
    console.error(`Error parsing JSON data for key: ${key}`, error);
    return null;
  }
}

export function parseJwt(token:string) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export function jwtIsValid(token:string){
  if(!token) return false;

  let valid = false;
  try{
    const parsedToken = parseJwt(token);
    if(parsedToken?.exp){
      valid =  parsedToken.exp * 1000 > new Date().getTime()
    }
    return valid;
  }catch (error){
    return false
  }


}

export const GLOBAL_COLORS = {
  grey:process.env.REACT_APP_GREY_COLOR,
  font:process.env.REACT_APP_FONT_COLOR,
  icon_color:process.env.REACT_APP_ICON_COLOR,
  primary:process.env.REACT_APP_PRIMARY_COLOR,
  secondary:process.env.REACT_APP_SECONDARY_COLOR,
  tertiary:process.env.REACT_APP_TERTIARY_COLOR,
  grey_secondary:process.env.REACT_APP_GREY_SECONDARY_COLOR,
  white_smoke:process.env.REACT_APP_WHITE_SMOKE_COLOR,
}

export const fillUpLearningHoursGraph = (daysTotal, chartRef) => {
  const xValues = [];
  const yValues = [];
  for (const date in daysTotal) {
    if (daysTotal.hasOwnProperty(date)) {
      const dayName = new Date(date).toLocaleString('en-us', {
        weekday: 'short',
      });

      const [year, month] = date.split('-');
      const formattedDate = `${dayName} ${parseInt(month)}/${year.slice(-2)}`;
      xValues.push(formattedDate);
      console.log(daysTotal[date], formattedDate);
      yValues.push((daysTotal[date] / 60).toFixed(0));
    }
  }

  const barColors = Array(xValues.length).fill('rgba(104, 169, 222, 0.61)');

  const ctx: any = document.getElementById('learningHoursGraph');
  chartRef.current = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: xValues,
      datasets: [
        {
          backgroundColor: barColors,
          data: yValues,
          label: 'Minutes',
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: 'Minutes',
          },
        },
      },
      plugins: {
        legend: {
          display: true,
        },
      },
    },
  });
};

export const handleLogout = () => {

  api.iblwebauth.logout({}, (logoutUrl) => {
    window.location.href = `${logoutUrl}?redirect_to=${process.env.REACT_APP_IBL_SPA_AUTH_URL}/logout?redirect-to=${window.location.origin}/logout`;
  });

};


